'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './housing_requirements.routes';

export class HousingRequirementsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.housing_requirements', [uiRouter])
  .config(routes)
  .component('housingRequirements', {
    template: require('./housing_requirements.html'),
    controller: HousingRequirementsComponent,
    controllerAs: 'housingRequirementsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_requirements/housing_requirements.component.js